export interface MailingList {
  name: string;
  members: number;
  messages: number;
}
